module.exports = __webpack_public_path__ + "static/img/459.79c16ad.png";